<!--
 * @Author: Shen Kui
 * @Description: 对象信息
-->
<template>
  <div class="absolute h-[calc(100%-140px)] w-368px right-0px top-66px z-100">
    <div class="p-10px component-container h-full">
      <div
        class="text-hex-fff text-24px h-46px w-full bg-no-repeat flex items-center py-10px px-10px"
      >
        三维寻阀
      </div>
      <el-table
        ref="markerTable"
        :data="tableData"
        v-loading="tableLoading"
        height="calc(100% - 178px)"
        :row-key="(row) => row.tagId"
        class="mt-10px p-10px"
        :cell-style="{ 'text-align': 'center' }"
        :header-cell-style="{ 'text-align': 'center' }"
        :highlight-current-row="true"
        @row-click="moveToPipe"
      >
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="阀门名称"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <span @click="viewValve(scope.row)" class="cursor-pointer">查看</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :visible.sync="detailDialogVisible"
      title="阀门详情"
      width="800px"
      :modal="false"
      v-dialogDrag
    >
      <el-form
        :model="detailForm"
        label-width="100px"
        v-loading="detailLoading"
        class="h-400px overflow-y-auto overflow-x-hidden"
      >
        <el-row :gutter="20">
          <el-col :span="12" v-for="item in basicAttributes" :key="item.value">
            <el-form-item :label="item.name">
              <el-input v-model="detailForm[item.value]" class="w-full" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import ThreeDimensionsService from '@/services/ThreeDimensions'
import ApiMixinTagObjectBrowse from '@/assets/js/api/tagObjectBrowse'

export default {
  name: 'valveSeeking',
  mixins: [ApiMixinTagObjectBrowse],
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {
        return {}
      },
    },
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      tableData: [],
      tableLoading: false,
      detailDialogVisible: false,
      detailForm: {},
      basicAttributes: [],
      detailLoading: false,
    }
  },
  watch: {
    'transferProps.tagCode': {
      handler(newVal) {
        if (newVal) {
          this.getTableData()
        }
      },
    },
  },
  methods: {
    viewValve(row) {
      this.detailDialogVisible = true
      this.getAttributes(row.id)
    },
    async getAttributes(tagId) {
      this.basicAttributes = this.$options.data().basicAttributes
      this.detailLoading = true
      const res = await this.apiTags({
        method: 'list',
        params: {
          id: tagId,
          standardId: this.transferProps.standardId,
        },
      })
      if (res && res.code === 0 && res.data) {
        this.detailForm.name = res.data.tag.name
        this.detailForm.code = res.data.tag.code
        const attributes = _.map(res.data.classAndAttributes.attributes, (item) => {
          const value = item.attrbuteDetail.code
          this.detailForm[value] = item.attrValue
          return {
            name: item.attrbuteDetail.name,
            value,
          }
        })
        this.basicAttributes = _.concat(this.basicAttributes, attributes)
      }
      this.detailLoading = false
    },
    // 获取管线表数据
    async getTableData() {
      this.tableData = []
      this.tableLoading = true
      const res = await ThreeDimensionsService.getValveList({
        code: this.transferProps.tagCode,
        standardId: this.transferProps.standardId,
      })
      if (res?.code === 0) {
        this.tableData = res.data
      }
      this.tableLoading = false
    },
    async markerHover(item) {
      const newimgId = await this.player.Native.GisMarker.loadImage('rgba:0,0,0,127')
      if (item.markerId !== 0) {
        await this.player.Native.GisMarker.setProperty(item.markerId, {
          imgId: newimgId,
          textColor: 0xffffffff,
        })
      }
    },
    async markerLeave(item) {
      // 创建一个透明的图片，用于隐藏
      const imgId = await this.player.Native.GisMarker.loadImage('rgba:0,0,0,0')
      await this.player.Native.GisMarker.setProperty(item.markerId, {
        imgId,
        textColor: 0xffffff00,
      })
    },
    async moveToPipe(row) {
      await this.cloudRender.Marker.destroyAllMarker()
      this.player.Native.GisMarker.EventGisMarkerHover.disconnect(this.markerHover)
      this.player.Native.GisMarker.EventGisMarkerLeave.disconnect(this.markerLeave)
      if (row.code) {
        const rootNode = await this.player.Native.Node.getRoot()
        const codeData = await this.player.Native.Node.findNode(rootNode, {
          codes: [row.code],
        })
        const codes = codeData?.codes
        if (codes && codes[row.code] && codes[row.code].node) {
          // 计算节点包围盒
          const nodeInfo = await this.player.Native.Node.getProperty(codes[row.code].node, ['aabb'])
          const calculateValue = (aabb) => {
            const minPoint = aabb[0]
            const maxPoint = aabb[1]

            const dx = maxPoint[0] - minPoint[0]
            const dy = maxPoint[1] - minPoint[1]
            const dz = maxPoint[2] - minPoint[2]

            const L = Math.sqrt(dx ** 2 + dy ** 2 + dz ** 2)
            const value = 0 + 6.5 / (1 + Math.log(L + 1))
            return value
          }
          // 相机移动到包围盒位置
          this.player.Native.Camera.moveToAabbWithDistance(
            nodeInfo.aabb,
            2,
            25,
            calculateValue(nodeInfo.aabb)
          )
          this.player.Native.Node.selectNodes([codes[row.code].node])
          this.player.Native.GisMarker.EventGisMarkerHover.connect(this.markerHover)
          this.player.Native.GisMarker.EventGisMarkerLeave.connect(this.markerLeave)
          const nodeResult = await this.cloudRender.NodeProxy.getInfo('Code', row.code)
          if (nodeResult.status) {
            const nodeData = nodeResult.data.nodeInfo
            const text = `Code: ${nodeData.code}`
            const aabb = nodeData.aabb
            const pos = []
            pos[0] = aabb[0][0] + (aabb[1][0] - aabb[0][0]) * 0.5 // x坐标
            pos[1] = aabb[0][1] + (aabb[1][1] - aabb[0][1]) * 0.5 // y坐标
            pos[2] = aabb[0][2] + (aabb[1][2] - aabb[0][2]) // z坐标
            await this.cloudRender.Marker.createBySingleLine({
              id: row.code,
              pos,
              background: 'transparent',
              visible: true,
              text,
              textColor: '#ffffffff',
              nodeOffset: [0, -60],
              markPosType: 1,
            })
          }
        }
      }
    },
  },
  created() {
    this.getTableData()
  },
  async beforeDestroy() {
    const rootNode = await this.player.Native.Node.getRoot()
    if (rootNode) {
      await this.player.Native.Node.setProperty(rootNode, { visible: true })
    }
  },
}
</script>

<style lang="scss" scoped>

@import '../../documentBrowseVk/css/index.scss';

.component-container,
::v-deep .el-dialog {
  background-image: url('../../../../resource/assets/images/container_bg.png');
  background-size: 100% 100%;
}
::v-deep .el-dialog {
  background-color: transparent !important;
  .el-dialog__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom-color: #0680e9;
    .el-dialog__title {
      font-size: 24px;
      line-height: 40px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff !important;
    }
  }
  .el-dialog__body {
    overflow-y: hidden !important;
  }
  .el-dialog__footer {
    background-color: transparent;
    border-top-color: #0680e9;
  }
}

</style>
